import { useAuth } from "@/hooks/useAuth";
import { ROLE } from "@/middleware.constant";
import { useRouter } from "next/router";
import React from "react";

import { Card, CardContent } from "@/components/ui/card";
import LICENSE_STATUS from "@/constants/licenseStatus";
import { useAssistance } from "@/context/assistanceProvider";

export default function TrialCreditExhaustionMessageCard() {
  const router = useRouter();
  const { isBlocked } = useAssistance();

  const { user } = useAuth();

  const isAdministrator =
    user &&
    (user?.attributes?.role_numeric == ROLE.ADMIN ||
      user?.attributes?.role_numeric == ROLE.OWNER);

  if (!isBlocked) return null;

  return (
    <Card className="my-5 dark:border-input">
      <CardContent className="relative text-[1.3rem] py-6 px-6">
  
        {isAdministrator ? (
          <p className="text-[1.3rem] text-foreground/70 mb-4">
            Your trial credits have been fully utilized. Please upgrade your
            plan.
          </p>
        ) : (
          <p className="text-[1.3rem] text-foreground/70 mb-4">
            Your trial credits have been fully utilized. Contact your admin to
            upgrade to a subscription plan.
          </p>
        )}

        <div className="flex justify-between">
          {isAdministrator &&
            user?.attributes?.license_status == LICENSE_STATUS.FULL_ACCESS && (
              <span
                onClick={() => router.push("/plans")}
                className="hover:underline underline-offset-2 cursor-pointer font-semibold "
              >
                Upgrade Plan
              </span>
            )}
        </div>
      </CardContent>
    </Card>
  );
}
